import { withPrefix } from 'gatsby'
import WordData from '../../utils/WordData'
const ASSETS_BASE_URL = withPrefix('/phaser/images/bedroom')

export const BACKGROUND_CONTEXT = ASSETS_BASE_URL + '/background.png'
const argentis = process.env.LOCALE === 'es-arg';
// DUERME COMODA Y SEGURA USANDO TOALLAS NOSOTRAS MAXIMA PROTECCION
export const WORD_LIST = [
  {
    stickPosX: 515,
    stickPosY: 156,
    word: argentis ? 'dormí' : 'duerme',
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + `/set1/${argentis ? 'dormi_arg' : 'duerme'}.png`,
  },
  {
    stickPosX: 756,
    stickPosY: 430,
    word: 'cómoda',
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set1/comoda.png',
  },
  {
    stickPosX: 309,
    stickPosY: 384,
    word: 'y',
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set1/y.png',
  },
  {
    stickPosX: 974,
    stickPosY: 356,
    word: 'segura',
    blendType: 'NORMAL',
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set1/segura.png',
  },
  {
    stickPosX: 171,
    stickPosY: 352,
    word: 'usando',
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set1/usando.png',
  },
  {
    stickPosX: 707,
    stickPosY: 266,
    word: 'toallas',
    blendType: 'NORMAL',
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set1/toallas.png',
  },
  {
    stickPosX: 1144,
    stickPosY: 216,
    word: 'nosotras',
    blendType: 'NORMAL',
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set1/nosotras.png',
  },
  {
    stickPosX: 423,
    stickPosY: 237,
    word: 'máxima',
    blendType: 'NORMAL',
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set1/maxima.png',
  },
  {
    stickPosX: 1307,
    stickPosY: 351,
    word: 'protección',
    blendType: 'NORMAL',
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set1/proteccion.png',
  }
].map((data) => new WordData(data));


/// LAS TOALLAS INVISIBLES ABSORBEN IGUAL QUE UNA TOALLA GRUESITA
export const WORD_LIST_2 = [
  {
    "stickPosX": 854.5,
    "stickPosY": 110,
    "word": "las",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set2/las.png"
  },
  {
    "stickPosX": 849.5,
    "stickPosY": 323,
    "word": "toallas",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set2/toallas.png"
  },
  {
    "stickPosX": 112.5,
    "stickPosY": 201,
    "word": "invisibles",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set2/invisibles.png"
  },
  {
    "stickPosX": 615.5,
    "stickPosY": 309,
    "word": "absorben",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set2/absorben.png"
  },
  {
    "stickPosX": 929,
    "stickPosY": 237,
    "word": "igual",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set2/igual.png"
  },
  {
    "stickPosX": 1260.5,
    "stickPosY": 395,
    "word": "que",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set2/que.png"
  },
  {
    "stickPosX": 766.5,
    "stickPosY": 110,
    "word": "una",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set2/una.png"
  },
  {
    "stickPosX": 548.5,
    "stickPosY": 140,
    "word": "gruesita",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set2/gruesita.png"
  }
].map((data) => new WordData(data));

///TU ZONA V SIEMPRE LIMPIA Y SEGURA DURANTE Y FUERA DEL PERIODO
export const WORD_LIST_3 = [
  {
    stickPosX: 1118,
    stickPosY: 308,
    word: 'tu',
    blendType: "NORMAL",
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set3/tu.png',
  }, {
    stickPosX: 830,
    stickPosY: 380,
    word: 'zona v',
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set3/zona_v.png',
  }, {
    stickPosX: 386,
    stickPosY: 145,
    word: 'siempre',
    blendType: "NORMAL",
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set3/siempre.png',
  }, {
    stickPosX: 704,
    stickPosY: 289,
    word: 'limpia',
    blendType: "NORMAL",
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set3/limpia.png',
  }, {
    stickPosX: 1266.5,
    stickPosY: 327,
    word: 'y',
    blendType: "NORMAL",
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set3/y.png',
  }, {
    stickPosX: 489,
    stickPosY: 31,
    word: 'segura',
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set3/segura.png',
  }, {
    stickPosX: 292,
    stickPosY: 245,
    word: 'durante',
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set3/durante.png',
  }, {
    stickPosX: 1003,
    stickPosY: 328,
    word: 'y',
    blendType: "NORMAL",
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set3/y2.png',
  }, {
    stickPosX: 764.5,
    stickPosY: 61,
    word: 'fuera',
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set3/fuera.png',
  }, {
    stickPosX: 931,
    stickPosY: 238,
    word: 'del',
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set3/del.png',
  }, {
    stickPosX: 1144,
    stickPosY: 214,
    word: 'periodo',
    blendType: "NORMAL",
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set3/periodo.png',
  }
].map((data) => new WordData(data));
